/* @flow */

import * as React from 'react';

type Props = {
  +onChange: (entry: IntersectionObserverEntry) => void,
};

const IntersectionWaypoint = ({ onChange }: Props): React.Node => {
  const elementRef = React.useRef<HTMLElement | null>(null);

  React.useEffect(() => {
    const currentElement = elementRef.current;

    if (!currentElement) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        onChange(entry);
      },
      {
        root: null,
        /*
         * Looks at a 1px line exactly 150px down from the top of the screen:
         * when a section container passes this line, it triggers an event
         */
        rootMargin: '-150px 0px -84% 0px',
        threshold: 0,
      },
    );

    observer.observe(currentElement);

    return () => observer.disconnect();
  }, [onChange]);

  return (
    <div
      ref={elementRef}
      style={{
        height: '100%',
        left: 0,
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: -1,
      }}
    />
  );
};

export default IntersectionWaypoint;
